import { DataLayerEvent } from './types';

declare global {
  interface Window {
    adobeDataLayer?: DataLayerEvent[];
  }
}

export const pushToAdobeDataLayer = (event: DataLayerEvent): void => {
  (window.adobeDataLayer ??= []).push(event);
  console.info('Pushed to Adobe Data Layer:', event);
};
